import styled from '@emotion/styled';
import { useState, useRef } from 'react';
import { MOBILE_QRY } from '~/config';
import CloseButton from '~/components/CloseButton';
import Header from '~/components/Header';
import InvoiceForm from './InvoiceForm';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { INVOICE_LIST_ROUTE } from '~/constants/routes';
import TemplateSelector from './TemplateSelector';
import InvoiceFormPhone from './InvoiceFormPhone';
import { useIsDesktop } from '~/hooks/useIsDesktop';
import WarningModal from './WarningModal';

const Wrapper = styled.div`
  background: var(--content1);
  padding: 0;
  min-height: 100vh;

  ${MOBILE_QRY} {
    padding: 48px;
  }
`;

const AddInvoice = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const editInvoiceUuid = searchParams.get('editUuid') as string;
  const isDesktop = useIsDesktop();
  const [showWarningModal, setShowWarningModal] = useState(false);
  const isNavigatingAway = useRef(false);

  const handleClose = () => {
    setShowWarningModal(true);
  };

  const handleConfirmClose = () => {
    isNavigatingAway.current = true;
    navigate(INVOICE_LIST_ROUTE);
  };

  const handleCancelClose = () => {
    setShowWarningModal(false);
  };

  return (
    <div>
      <Header
        headerText={editInvoiceUuid ? 'Edit Invoice' : 'New Invoice'}
        rightJsx={<CloseButton onClose={handleClose} />}
      />
      <Wrapper>
        <TemplateSelector />

        {isDesktop ? <InvoiceForm /> : <InvoiceFormPhone />}
      </Wrapper>

      <WarningModal
        isVisible={showWarningModal}
        onConfirm={handleConfirmClose}
        onCancel={handleCancelClose}
      />
    </div>
  );
};

export default AddInvoice;
